import React, { useState } from 'react';
import { Card, Container, Row, Col, Modal } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import 'bootstrap/dist/css/bootstrap.min.css';
import './EyeCategory.css';

// Images
import eyeImage1 from '../images/crystaleyes2.png';
import eyeImage2 from '../images/sparkale1.png';
import eyeImage3 from '../images/glasseyes.png';
import eyeImage4 from '../images/redcrystal.jpg';
import eyeImage5 from '../images/PrintedEyes.png';
import eyeImage6 from '../images/DotEyes.png';
import eyeImage7 from '../images/ButtonEyes.png';

const products = [
  { title: "Crystal Brown Eyes", image: eyeImage1, alt: "plastic safety eyes brown crystal manufacturer India" },
  { title: "Sparkle Eyes", image: eyeImage2, alt: "sparkle soft toy eyes supplier India" },
  { title: "Glass-Like Eyes", image: eyeImage3, alt: "glass type plastic safety eyes bulk India" },
  { title: "Crystal Red Eyes", image: eyeImage4, alt: "red crystal safety eyes manufacturer India" },
  { title: "Printed Eyes", image: eyeImage5, alt: "printed toy eyes supplier India" },
  { title: "White Dot Eyes", image: eyeImage6, alt: "white dot safety eyes for plush toys" },
  { title: "Button Eyes", image: eyeImage7, alt: "button eyes manufacturer for soft toys India" }
];

const EyeCategory = () => {
  const [show, setShow] = useState(false);
  const [modalImage, setModalImage] = useState('');
  const [modalAlt, setModalAlt] = useState('');

  const handleClose = () => setShow(false);

  const handleShow = (image, alt) => {
    setModalImage(image);
    setModalAlt(alt);
    setShow(true);
  };

  return (
    <>
      <Helmet>
        <title>
          Plastic Safety Eyes Manufacturer in India | Soft Toy Eyes Bulk Supplier | Pushkar Enterprises
        </title>

        <meta
          name="description"
          content="Explore plastic safety eyes in bulk from Pushkar Enterprises, a leading soft toy eyes manufacturer in India. Crystal, sparkle, printed & button eyes available for plush toys."
        />

        <meta
          name="keywords"
          content="plastic safety eyes manufacturer India, soft toy eyes bulk supplier, amigurumi eyes India, teddy bear eyes wholesale, toy eyes manufacturer Delhi"
        />

        <link rel="canonical" href="https://pushkar-enterprises.web.app/eyes" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      {/* 🔥 MAIN SEO HEADING */}
      <header>
        <h1 className="category-heading">
          Plastic Safety Eyes Manufacturer in India
        </h1>

        <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
          Soft Toy Eyes, Amigurumi Eyes & Teddy Bear Eyes Supplier in Delhi
        </h2>
      </header>

      {/* 🔥 SEO CONTENT (VERY IMPORTANT) */}
      <Container style={{ maxWidth: "900px", marginBottom: "30px" }}>
        <p>
          Pushkar Enterprises is a leading <strong>plastic safety eyes manufacturer in India </strong> 
           supplying high-quality <strong>soft toy eyes, teddy bear eyes, and amigurumi eyes </strong> 
          for plush toy manufacturers and exporters. Our products are designed for strong locking, 
          smooth finishing, and long-lasting durability.
        </p>

        <p>
          We offer a wide range of <strong>toy eyes in different sizes, colors, and finishes </strong> 
           including crystal eyes, sparkle eyes, printed eyes, and button eyes. Our products are widely 
          used in stuffed toys, crochet toys, and plush manufacturing industries across India and worldwide.
        </p>
      </Container>

      {/* PRODUCT GRID */}
      <Container className="eye-category">
        <Row className="card-container">
          {products.map((item, index) => (
            <Col md={3} sm={6} xs={12} key={index} className="mb-4">
              <Card
                className="product-card"
                onClick={() => handleShow(item.image, item.alt)}
              >
                <Card.Img
                  variant="top"
                  src={item.image}
                  alt={item.alt}
                  loading="lazy"
                />
                <Card.Body>
                  <Card.Title>{item.title}</Card.Title>
                  <Card.Text>Available for Bulk Orders</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

      {/* 🔥 EXTRA SEO CONTENT */}
      <Container style={{ maxWidth: "900px", marginTop: "20px" }}>
        <h2>Bulk Supply of Soft Toy Eyes in India</h2>

        <p>
          As a Delhi-based manufacturer, we specialize in bulk supply of plastic safety eyes 
          for toy manufacturers, exporters, and wholesalers. We ensure consistent quality, 
          competitive pricing, and reliable delivery for large-scale orders.
        </p>

        <p>
          Contact Pushkar Enterprises for wholesale inquiries and custom requirements for 
          soft toy eyes and accessories.
        </p>
      </Container>

      {/* MODAL */}
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Body>
          <img src={modalImage} alt={modalAlt} className="img-fluid" />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default EyeCategory;